import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { GetFinanceTradesRequestModel, GetFinanceTradesResponseModel } from "@/features/accounts/finance/services/get-trades-model";

export class GetFinanceTradesApi {
  /**
   * 銀行明細取得API
   */
  public getFinanceTrades = async (
    param: GetFinanceTradesRequestModel
  ): Promise<GetFinanceTradesResponseModel[]> => {
    const path = `/api/financeaccounts/finances/trades`;
    const res = await ApiClient.instance.get<GetFinanceTradesResponseModel[]>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
